module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo21.9bb30b19.jpg";